import { useState, useEffect } from "react"
import { useGetAdvisorUsersMutation } from "./userApiSlice"
import { useGetDocuSignAccountMutation, useConnectDocusignMutation } from "../form/formApiSlice"
import { useDispatch, useSelector } from 'react-redux'
import { showSpinner, hideSpinner } from "../../components/componentSlice"
import SearchableDropdown from "../../components/SearchableDropdown"
import { message, Popconfirm, Alert, Spin } from 'antd'

const ConnectDocusign = () => {

    const [selectedAdvisor, setSelectedAdvisor] = useState(null)
    const [advisors, setAdvisors] = useState([])
    const [searchValue, setSearchValue] = useState("")
    const [errorMessage, setErrorMessage] = useState(null)
    const [isConnectStarted, setConnectStarted] = useState(false)
    const [docusignAccount, setDocusignAccount] = useState(null)
    const [isConnectionChecked, setConnectionChecked] = useState(false)

    const [messageApi, contextHolder] = message.useMessage()
    const dispatch = useDispatch()

    const [ getAdvisorUsers,  {isLoading: isGetAllAdvisorsLoading}] = useGetAdvisorUsersMutation()
    const [getDocuSignAccount, { isLoading }] = useGetDocuSignAccountMutation()
    const [connectDocusign, { isLoading: isConnectDocusignLoading }] = useConnectDocusignMutation()

    const alertMessage = (message) => {
        messageApi.success(message);
    }

    useEffect(() => {
        if(isLoading || isConnectDocusignLoading) {
            dispatch(showSpinner())
        } else{
            dispatch(hideSpinner())
        }
    }, [isLoading, isConnectDocusignLoading])

    useEffect(() => {
        async function handleGetAdvisors() {
          const response = await getAdvisorUsers()
          setAdvisors(response.data)
        }
        handleGetAdvisors()
    }, [])

    useEffect(() => {
        if(isConnectStarted && !docusignAccount && selectedAdvisor) {
            const interval = setInterval(() => {checkAccountConnected(selectedAdvisor)}, 5000)
            return () => clearInterval(interval)
        }
    }, [isConnectStarted, docusignAccount, selectedAdvisor])

    const getAdvisorOption = () => {
        return advisors?.map(advisor => ({id: advisor.id, name: advisor.username}))
    }

    const onChangeSearch = (value, id) => {
        if(id) {
            setDocusignAccount(null)
            setSelectedAdvisor(id)
            checkAccountConnected(id)
            setConnectStarted(false)
        }
        setSearchValue(value)
    }

    const connectToDocuSign = async () => {
        try {
            const response = await connectDocusign(selectedAdvisor).unwrap()
            if(response) {
                const authUrl = response.url
                setConnectStarted(true)
                window.location.href = authUrl
            }
        } catch(err) {
            if(!err.status || err.status === "FETCH_ERROR") {
                setErrorMessage("No Server Response")
            } else {
                setErrorMessage(err.data?.detail)
            }
        }
    }

    const checkAccountConnected = async (advisorId) => {
        try {
            const response = await getDocuSignAccount(advisorId).unwrap()
            setDocusignAccount(response)
            setConnectionChecked(true)
            
        } catch(err) {
            if(!err.status || err.status === "FETCH_ERROR") {
                setErrorMessage("No Server Response")
            } else {
                setErrorMessage(err.data?.detail)
            }
        }
    }

    const createDocusignView = () => {
        return docusignAccount ? createConnectedView() : createNotConnectedView()
    }

    const createNotConnectedView = () => {
        return (
            <>
                <Alert
                    showIcon
                    description="DocuSign account has not been connected yet."
                    type="warning"
                    banner
                />
                <Spin size="large" spinning={isConnectStarted}>
                    <div className="docusign-button">
                        <button className="crm-button crm-btn-primary" onClick={() => connectToDocuSign()}>
                            Connect to DocuSign
                        </button>  
                    </div>   
                </Spin>   
            </>
        )
    }

    const createConnectedView = () => {
        return (
            <Alert
                showIcon
                description={`Advisor is connected to a Docusign account with email: ${docusignAccount?.email}`}
                type="success"
                banner
            />
        )
    }

    return (
        <div className="manage-user-container">
            {contextHolder}
            <div className='top-header'>
                <header>Connect Docusign</header>
            </div>
            {errorMessage && 
                <div className="errorMessage">
                    <p>{errorMessage}</p>
                </div>
            }
            <div className="delete-body">
                <div className="search-container">
                    <SearchableDropdown
                        options={getAdvisorOption()}
                        label="name"
                        id="id"
                        placeholderVal={"Select advisor..."}
                        selectedVal={searchValue}
                        handleChange={(val, id) => onChangeSearch(val, id)}
                    />
                </div>

                {selectedAdvisor && createDocusignView()}              
            </div>
        </div>
    )
}

export default ConnectDocusign